module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921014151_T.81f7f786.jpg";